export function getPossessive(subject?: string | number | null): string {
  if (!subject) return '';

  const lastCharacter = subject?.toString().slice(-1).toLowerCase();
  return lastCharacter === 's' ? subject + "'" : subject + "'s";
}
